import { gql } from "@apollo/client";

// USDT top-ups paid straight to the company's Ledger (backend:
// src/payments/ledger): every incoming transfer, its AML screen, the top-up
// it paid, and the admin's decisions on the held ones.

const CRYPTO_TRANSFER_FIELDS = `
  id
  txHash
  explorerUrl
  testnet
  network
  asset
  fromAddress
  toAddress
  amount
  blockTimestamp
  amlStatus
  amlChecks {
    name
    status
    detail
    score
    reportUrl
    checkedAt
  }
  amlRiskScore
  amlCheckedAt
  resolvedBy
  resolvedAt
  payment {
    id
    hashId
    status
    creditedUsd
    requestedUsd
    expectedAmount
    userId
    userEmail
  }
`;

export const GET_CRYPTO_TRANSFERS = gql`
  query cryptoTransfers(
    $amlStatus: CryptoAmlStatus
    $unmatched: Boolean
    $offset: Int
    $limit: Int
  ) {
    cryptoTransfers(
      amlStatus: $amlStatus
      unmatched: $unmatched
      offset: $offset
      limit: $limit
    ) {
      total
      items {
        ${CRYPTO_TRANSFER_FIELDS}
      }
    }
  }
`;

export const APPROVE_CRYPTO_TRANSFER = gql`
  mutation approveCryptoTransfer($id: Int!) {
    approveCryptoTransfer(id: $id) {
      ${CRYPTO_TRANSFER_FIELDS}
    }
  }
`;

export const REJECT_CRYPTO_TRANSFER = gql`
  mutation rejectCryptoTransfer($id: Int!) {
    rejectCryptoTransfer(id: $id) {
      ${CRYPTO_TRANSFER_FIELDS}
    }
  }
`;

export const ATTACH_CRYPTO_TRANSFER = gql`
  mutation attachCryptoTransfer($id: Int!, $paymentHashId: String!) {
    attachCryptoTransfer(id: $id, paymentHashId: $paymentHashId) {
      ${CRYPTO_TRANSFER_FIELDS}
    }
  }
`;

const CRYPTO_SETTINGS_FIELDS = `
  mode
  testerEmails
  addressConfigured
  address
  updatedAt
  updatedBy
`;

export const GET_CRYPTO_PAYMENTS_SETTINGS = gql`
  query cryptoPaymentsSettings {
    cryptoPaymentsSettings {
      ${CRYPTO_SETTINGS_FIELDS}
    }
  }
`;

export const UPDATE_CRYPTO_PAYMENTS_SETTINGS = gql`
  mutation updateCryptoPaymentsSettings(
    $mode: CryptoPaymentsMode!
    $testerEmails: [String!]!
  ) {
    updateCryptoPaymentsSettings(mode: $mode, testerEmails: $testerEmails) {
      ${CRYPTO_SETTINGS_FIELDS}
    }
  }
`;
